module.exports = __webpack_public_path__ + "img/LA.229a7afe.svg";